/* eslint-disable */
import React, { useCallback, useState } from "react";
import Container from "../UI/Container";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { usePopUpContext } from "../../Context/PopupMessage";
import SwitchPro from "../UI/switchPro";
import { useReactToPrint } from "react-to-print";
import { maxColumnWidth } from "../../util";
import InventoryPdf from "./invenoryStatusPdf";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
var pixelWidth = require('string-pixel-width');
import {
  Box,
  Button,
  Stack,
  Autocomplete,
  TextField,
  Menu,
  MenuItem, 
  Grid
} from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import axios from "../../api";
import MaterialPropertiesModal from "../UI/MaterialProperties";
import { useMaterialPropertiesContext } from "../../Context/MaterialPropertiesContext";
import MendetoryIcon from "../UI/mendetoryicon";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useGlobalDataContext } from "../../Context/AppGlobalData";
function BrowseContainer(props) {
  
  const { inventoryAtValue, setInventoryAtValue,  millValue, setMillValue } = useGlobalDataContext();
  const [selectedFilter, setSelectedFilter] = useState([])
  const [pdfFilter, setPdfFilter] = useState([])
  const [assetColumns, setColumns] = useState([
    {
      field: "partNo",
      headerName: "Part No",
      sortable: false,
      width: 120,
    },
    {
      field: "cusPoNo",
      headerName: "Mill Order No",
      sortable: false,
      width: 120,
    },
    {
      field: "eusrPoNo",
      headerName: "End-User PO",
      sortable: false,
      width: 120,
    },
    {
      field: "cusTagNo",
      headerName: "Mill Coil ID",
      sortable: false,
      width: 120,
    },
    {
      field: "procrCoilStf",
      headerName: "Processor Coil ID",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 150,
    },
    {
      field: "wgtStr",
      headerName: "LBS",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      type: 'number',
      field: "pcsStr",
      headerName: "Pieces",
      sortable: false,
      width: 80,
    },
    {
      field: "gaStr",
      headerName: "Gauge",
      sortable: false,
      width: 100,
    },
    {
      field: "wdthStr",
      headerName: "Width",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "lgthStr",
      headerName: "Length",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "stsDesc",
      headerName: "Status",
      sortable: false,
      width: 200,
    },
    {
      field: "invtTypDesc",
      headerName: "Reservation",
      sortable: false,
      width: 190,
    },
    {
      field: "origRefDts",
      headerName: "Date",
      sortable: false,
      width: 150,
    },
  ]);
  const { setPopupMessage, setLoading } = usePopUpContext();

  const getAll = async (postData) => {
    setLoading(true)
    let success = true
    let flag = true;
    let nextTotal = null
    let nextRecord = null
    let frstTmFlg = 1
    let rowsData = []
    let nTotWgt
    let nRowID
    let wgtUm ="LBS"
    while (flag) {

      if (nextRecord) {
        postData["sTagCtlNo"] = nextRecord;
        postData["sTotPcs"] = nextTotal
        postData["sTotWgt"] = nTotWgt
        postData["sRowId"] = nRowID
      }

      postData["frstTmFlg"] = frstTmFlg

      await axios
        .post("/invbrowse", postData /*axiosConfig*/)
        .then((res) => {

          // if(res.data.output.rtnSts === 0 ){

          // }else{
          //   setPopupMessage({ state: true, type: "error", message: err.response.data?.msg })
          // }
          frstTmFlg = 0
          rowsData = [...rowsData, ...res.data.output.fldTbl]
          if (res.data.output.eof === 0) {
            flag = true
            nextRecord = res.data.output.nTagCtlNo;
            nextTotal = res.data.output.nTotPcs;
            nTotWgt = res.data.output.nTotWgt
            nRowID = res.data.output.nRowId
          } else {
            flag = false
          }
          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }
          wgtUm = res.data.output.wgtUm

        })
        .catch((err) => {
          setLoading(false)
          success = false
          flag = false
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
          let data = { success: false, rowsData: rowsData }
          return data
          // setRows([]);
        });
    }
    setLoading(false)
    let data = { success: true, rowsData: rowsData,wgtUm:wgtUm }
    return data

  }
   const usertype =localStorage.getItem("type")
   let detaildata =JSON.parse(localStorage.getItem("detail"))
  React.useEffect(() => {

   
   if(usertype && usertype==="E"){
    setMillValue({keyStr:detaildata.cusNo,dispStr:detaildata.cusNm})
   }
   if(detaildata?.dsblBrh===1){
    setInventoryAtValue({keyStr:detaildata.brh,dispStr:detaildata.brhNm})
   }
  
  }, []);





  const handleGo = async (e, nextCall) => {
    e.preventDefault()
    setLoading(true)
    var postData = {
      prsMd: "P",
      brh: inventoryAtValue?.keyStr===""?"":inventoryAtValue?.keyStr,
      cusNo: millValue?.keyStr===""?null:Number(millValue?.keyStr),
    };
    var filter = {
      
      "Inventory At": inventoryAtValue?.dispStr,
      "Mill": millValue?.dispStr,
     
    }

    if (checked) {
      postData["useMetUnt"] = 1;
    } else {
      postData["useMetUnt"] = 0;
    }

    if (millOrderNoValue) {
      postData["cusPoNo"] = millOrderNoValue;
      filter["Mill Order No"] = millOrderNoValue;
    }

    if (endUserValue) {
      postData["eusrNo"] = Number(endUserValue.keyStr);
      filter["End-User"] = endUserValue.dispStr;
    }

    if (endUserPOValue) {
      postData["eusrPoNo"] = endUserPOValue;
      filter["End-User PO"] = endUserPOValue;
    }

    if (matStsValue) {
      postData["matSts"] = matStsValue.keyStr;
      filter["Status"] = matStsValue.dispStr;
    }

    if (invtTypValue) {
      postData["invtTyp"] = invtTypValue.keyStr;
      filter["Reservation"] = invtTypValue.dispStr;
    }

    if (partNoValue) {
      postData["partno"] = partNoValue.keyStr;
      filter["Part No"] = partNoValue.dispStr;
    } else if (partNoInputValue && partNoInputValue.trim() !== "") {
      postData["partno"] = partNoInputValue.trim();
      filter["Part No"] = partNoInputValue.trim();
    }

    if (widthFromValue) {
      postData["fmWdth"] = Number(widthFromValue);
      filter["From Width"] = widthFromValue;
    }

    if (widthToValue) {
      postData["toWdth"] = Number(widthToValue);
      filter["To Width"] = widthToValue;
    }

    if (lengthFromValue) {
      postData["fmLgth"] = Number(lengthFromValue);
      filter["From Length"] = lengthFromValue;
    }

    if (lengthToValue) {
      postData["toLgth"] = Number(lengthToValue);
      filter["To Length"] = lengthToValue;
    }

    if (gaugeFromValue) {
      postData["fmGa"] = Number(gaugeFromValue);
      filter["From Gauge"] = gaugeFromValue;
    }

    if (gaugeToValue) {
      postData["toGa"] = Number(gaugeToValue);
      filter["To Gauge"] = gaugeToValue;
    }
    setSelectedFilter(postData)
    setPdfFilter(filter)
    const data = await getAll(postData)
    if (data.success) {
      setLoading(false)
      setRows(data.rowsData);
      
      const updatedData = assetColumns.map(x => (
        x.field === "wgtStr"?{ ...x,headerName:data.wgtUm, width: maxColumnWidth(x.field, data.rowsData) }:     
        x.field !== "procrCoilStf" ? { ...x, width: maxColumnWidth(x.field, data.rowsData) } : 
      x));
      setColumns(updatedData)
    }

  };

  const apiRef = useGridApiRef();

  const [rows, setRows] = useState([]);
  const { setTagCtlNoValue, setPrsMdValue } = useMaterialPropertiesContext();
  const [openInventoryAt, setOpenInventoryAt] = useState(false);
  const [inventoryAtOption, setInventoryAtOption] = useState([]);
  const [openMill, setOpenMill] = useState(false);
  const [millOption, setMillOption] = useState([]);
  const [millOrderNoValue, setMillOrderNoValue] = useState(null);
  const [openEndUser, setOpenEndUser] = useState(false);
  const [endUserOption, setEndUserOption] = useState([]);
  const [endUserValue, setEndUserValue] = useState(null);
  const [endUserPOValue, setEndUserPOValue] = useState(null);
  const [matStsValue, setMatStsValue] = useState(null);
  const [invtTypValue, setInvtTypValue] = useState(null);
  const [openPartNo, setOpenPartNo] = useState(false);
  const [partNoOption, setPartNoOption] = useState([]);
  const [partNoValue, setPartNoValue] = useState(null);
  const [partNoInputValue, setPartNoInputValue] = useState("");
  const [widthFromValue, setWidthFromValue] = useState(null);
  const [widthToValue, setWidthToValue] = useState(null);
  const [lengthFromValue, setLengthFromValue] = useState(null);
  const [lengthToValue, setLengthToValue] = useState(null);
  const [gaugeFromValue, setGaugeFromValue] = useState(null);
  const [gaugeToValue, setGaugeToValue] = useState(null);
  const [filterVisibility, setFilterVisibility] = useState(true);
  const [dimensionFilterVisibility, setDimensionFilterVisibility] =
    useState(false);
  const [openMaterialPropertiesModal, setOpenMaterialPropertiesModal] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [checked, setChecked] = useState(false);

  const handleCellClick = (params) => {
    if (params.field === "procrCoilStf") {
      if (params.row.isTot !== 1) {
        setOpenMaterialPropertiesModal(true);
        setTagCtlNoValue(params.row.tagCtlNo);

        setPrsMdValue({
          useMetUnt: checked ? 1 : 0,
          prsMd: "I",
          tagCtlNo: params.row.tagCtlNo
        });
      }

    }
  };

  const handleMore = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getValue = (params, setValue, setOpen) => {
   
    setLoading(true)
    let url = "/lookupsvc";
    let headers = {
      "invera-service-name": "scbesv",
    };
    setValue([])
    console.log("params:", params);
    axios
      .post(url, params, headers)
      .then((res) => {
        setOpen(true);
        setLoading(false)
        var arrResponse = res.data.output.fldTbl;
        setValue(arrResponse);
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
       
      })
      .catch((e) => {
        console.log(e);
        setOpen(false);
        setLoading(false)
        setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
      });
  };

  const hideMaterialPropertiesModal = () => {
    setOpenMaterialPropertiesModal(false);
  };

  const toggleMetricUnits = useCallback(() => {
    setChecked((checked) => !checked);
  }, []);

  const dimensionFilterToggler = useCallback(() => {
    setDimensionFilterVisibility(
      (dimensionFilterVisibility) => !dimensionFilterVisibility
    );
  }, []);
  const clear = () => {
  
    setEndUserValue(null);
    setPartNoValue(null)
    setPartNoInputValue("")
    setMillOrderNoValue("")
    setMatStsValue( null);
     setInvtTypValue( null)
   setEndUserValue(null);
    setPartNoValue( null);
   setEndUserPOValue("")
   setChecked(false)
   setWidthFromValue('')
   setLengthFromValue('')
setGaugeFromValue('')
  setWidthToValue('')
   setLengthToValue('')
setGaugeToValue('')
   
  }
  const [reservations, setReservations] = useState([]);
  const [reservationOpen, setReservationOpen] = useState(false);

  const [statusOption, setStatusOption] = useState([]);
  const [statusOpen, setStatusOpen] = useState(false);
  const [typingTimer, setTypingTimer] = useState();
  const SearchServiceCall = (async (newValue, parms, setOption, setOpen) => {
    clearTimeout(typingTimer);
    if (newValue) {
      setOption([])
      const typingTimer_ = setTimeout(async () => {
        setLoading(true)
        //console.log("service call-------------------------------------------------")
        getValue(parms, setOption, setOpen);
      }, 1000);
      setTypingTimer(typingTimer_);
    } else {
      getValue({ prsMd: parms.prsMd }, setOption, setOpen);
    }
  });




//---------------------------------------- pdf------------------------------------------
  const [openPdf, setOpenPdf] = useState(null)
  const [wgtUm, setwgtUm] = useState("LBS")

  const handleAfterPrint = React.useCallback(() => {
    setOpenPdf(null)
    handleClose()
  }, []);

//Applying style to excel file
const addStyleToSheet = (workbookBlob, apiData) => {
  try {
    console.log("addStyleToSheet-----------------------")
      return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
          workbook.sheets().forEach((sheet) => {
              // Get the used range of the sheet
              const usedRange = sheet.usedRange();

              // Set the first row background color to green up to the last column with data
              const lastColumnNumber = usedRange._maxColumnNumber;
              let lastColumnLetter;
              if (lastColumnNumber <= 26) {
                  lastColumnLetter = String.fromCharCode(64 + lastColumnNumber);
              } else {
                  const firstLetter = String.fromCharCode(64 + Math.floor((lastColumnNumber - 1) / 26));
                  const secondLetter = String.fromCharCode(64 + ((lastColumnNumber - 1) % 26) + 1);
                  lastColumnLetter = `${firstLetter}${secondLetter}`;
              }
              // sheet.range(`A1:${lastColumnLetter}1`).style({
              //     fill: {
              //         type: "solid",
              //         color: "#90EE90"
              //     },
              //     // fgColor: { argb: 'FF90EE90' }, // Green color
              //     // color: "#ffffff",
              // });

              // Set the width of each column based on its maximum width
              for (let colNumber = 1; colNumber <= lastColumnNumber; colNumber++) {
                  const columnLetter = String.fromCharCode(64 + colNumber);
                  const column = sheet.column(columnLetter);

                  // Get the maximum width of the column
                  let maxWidth = 0;
                  const rowCount = usedRange._numRows;
                  for (let row = 1; row <= rowCount; row++) {
                      const cell = column.cell(row);
                      const cellValue = cell._value !== undefined ? cell._value.toString() : ''; // Convert value to string
                      // const cellWidth = cellValue.length;
                      maxWidth = Math.max(maxWidth, pixelWidth(cellValue, { size: 2 }));
                     // cell.value(cellValue); // Set the cell value as a string
                  }

                  // Set the width of the column
                  // column.autoSize();
                  // column.width(250); // Adjust the width as needed
                  column.width((maxWidth + 3) <= 100 ? maxWidth + 3 : 100); // Adjust the width as needed                     
                  column.style({ wrapText: true });
                  // Alternatively, you can set a specific width for all columns
                  // column.width(10); // Set a specific width for all columns
              }

          });

          return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
      }).catch((error) => {
          console.error("Error in addStyleToSheet", error);
          return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
              return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
          })
      });
  }
  catch (err) {
      console.error("Error in addStyleToSheet", err);
      return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
          return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
      })
  }
};
  const handleOnBeforeGetContent = React.useCallback(async () => {

    var postData = {
      ...selectedFilter,
      prsMd: "E",  // "E",
      fileFmt: "P",


    };

    const data = await getAll(postData)
    console.log("success", data)
    if (data.success) {
      setLoading(false)
      setwgtUm(data.wgtUm)
      setOpenPdf(data.rowsData);
    }


    return new Promise((resolve) => {
      resolve();


    });
  }, [[]]);

  const componentRef = React.useRef();
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);
  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: `InventoryStatus_${new Date().toJSON().slice(0, 10)}`,
    onBeforeGetContent: handleOnBeforeGetContent,
    removeAfterPrint: true,
    onAfterPrint: handleAfterPrint
  });

//---------------------------------------- xls------------------------------------------
 const exportToXls = async () => {
  let fileName =`InventoryStatus_${Date.now()}`
  var postData = {
    ...selectedFilter,
    prsMd: "E",  // "E",
    fileFmt: "X",


  };

  const apiData = await getAll(postData)
  if (apiData.success) { 
    let keyMap = {
    partNo: "Part No",
    prg: "Group",
    grd: "Grade",
    cusPoNo: "Mill Order No",
    eusrPoNo: "End-User PO",
    cusTagNo: "Mill Coil ID",
    procrCoilStf: "Processor Coil ID",
    wgt:apiData.wgtUm,
    pcs: "Pieces",
    gaStr: "Gauge",
    wdthStr: "Width",
    lgthStr: "Length",
    stsDesc: "Status",
    invtTypDesc: "Reservation",
    rcvDts: "Receiving Date",
    origRefDts: "Created Date"
  };

  setLoading(false);

  // Additional information
// Additional information


let pdfFilterString =  new Date().toDateString() + '\n'+'Inventory Status' + '\n' + 'Criteria : \n';
console.log(pdfFilter)
for (const key in pdfFilter) {
 
  if (pdfFilter.hasOwnProperty(key)) {
    pdfFilterString += key + ': ' + pdfFilter[key] + '\n';
  }
}
// Convert the additional information into an array of lines
const additionalInfoLines = pdfFilterString.split('\n').map(line => [line]);

// Map the API data to the desired format
let newData = additionalInfoLines; // Start with the additional info

// Create a header row based on keyMap
const headerRow = Object.values(keyMap);
newData.push(headerRow);

apiData.rowsData.forEach((rec) => {
  let mappedData = Object.keys(keyMap).reduce((obj, k) => {
    obj[keyMap[k]] = rec[k];
    return obj;
  }, {});
  newData.push(Object.values(mappedData));
});

const ws = XLSX.utils.aoa_to_sheet(newData);

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
const excelBuffer = await XLSX.write(wb, { bookType: "xlsx", type: "array" });
const data = new Blob([excelBuffer], { type: fileType });

//FileSaver.saveAs(data, `${fileName}.xlsx`);
addStyleToSheet(data, newData).then((url) => {
  FileSaver.saveAs(url, fileName + ".xlsx");
})



handleClose()
  }

};


//---------------------------------------- xls------------------------------------------
  return (
    <>

      {openMaterialPropertiesModal ? (
        <MaterialPropertiesModal
          open={true}
          onClose={hideMaterialPropertiesModal}
        />
      ) : null}
      <Container
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        {/* Filter */}
        {filterVisibility ? (
          <Container className="ixFilterContainer" sx={{ height: "auto" }}>
            {/* Displays Filter */}
            <form onSubmit={(e) => handleGo(e, 1)}>
              <Stack
                direction="row"
        
                spacing={9}>

                <Grid container sx={{ width: "80%" }} spacing={2} direction="row">
                  <Grid item xs={1} textAlign="end">Inventory At <MendetoryIcon /></Grid>
                  <Grid item xs={3}>
                   
                    <Autocomplete
                   noOptionsText="No items found"
                    open={openInventoryAt}
                    onOpen={() => {
                      getValue(
                        { prsMd: "B" },
                        setInventoryAtOption,
                        setOpenInventoryAt
                      );
                    }}
                    disabled={detaildata?.dsblBrh===1?true:false}
                    onClose={() => {
                      setOpenInventoryAt(false);
                    }}
                    value={inventoryAtValue?{dispStr:inventoryAtValue.dispStr}:null}
                    options={inventoryAtOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {

                      setInventoryAtValue(newValue ? newValue : null);
                      setRows([]);

                    }}
                    renderInput={(params) => <TextField   value={inventoryAtValue?{dispStr:inventoryAtValue.dispStr}:null} 
                    onChange={(e) => {SearchServiceCall(e.target.value, { prsMd: "B", srchStr: e.target.value }, setInventoryAtOption,
                      setOpenInventoryAt)
                    
                      setInventoryAtValue({ "keyStr": "",
                      "dispStr": e.target.value});
                    }
                    
                    }{...params} />
                  }
                  />
                  </Grid>
                  {usertype==="I" ? <>  <Grid item xs={1} textAlign="end">Mill <MendetoryIcon /></Grid>
                    <Grid item xs={3}>
                      <Autocomplete
                       noOptionsText="No items found"
                        open={openMill}
                        onOpen={() => {
                          getValue({ prsMd: "M" }, setMillOption, setOpenMill);
                        }}
                        onClose={() => {
                          setOpenMill(false);
                        }}
                        value={millValue?{dispStr:millValue.dispStr}:null}
                        options={millOption}
                        isOptionEqualToValue={(option, value) =>
                          option.dispStr === value.dispStr
                        }
                        getOptionLabel={(option) => option.dispStr}
                        onChange={(event, newValue) => {
                          console.log(newValue)
                          setMillValue(newValue ? newValue : 0);
                          setEndUserValue(null);
                          setPartNoValue(null)
                          setPartNoInputValue("")
                          setRows([]);

                        }}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            value={millValue?millValue.dispStr:""}
                            onChange={(e) =>{ SearchServiceCall(e.target.value, { prsMd: "M", srchStr: e.target.value }, setMillOption,
                              setOpenMill)
                              setMillValue({ "keyStr": "",
                              "dispStr": e.target.value});
                            
                            }
                            
                            }
                          />
                        )}
                      />
                    </Grid></> : null}

                  <Grid item xs={1} textAlign="end">Mill Order No</Grid>
                  <Grid item xs={3}>
                    <TextField
                      value={millOrderNoValue||""}
                      onChange={(e) => {
                        setMillOrderNoValue(e.target.value)
                        setRows([]);
                      }}
                    />
                  </Grid>
                  <Grid item xs={1} textAlign="end">Status</Grid>
                  <Grid item xs={3}>
                    <Autocomplete
                     noOptionsText="No items found"
                      options={statusOption}
                      open={statusOpen}
                      onOpen={() => {
                        statusOption.length < 1 ?
                          getValue(
                            { prsMd: "S" },
                            setStatusOption,
                            setStatusOpen
                          ) :

                          setStatusOpen(true);

                      }}
                      onClose={() => {
                        setStatusOpen(false);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.dispStr === value.dispStr
                      }
                      getOptionLabel={(option) => option.dispStr}
                      value={matStsValue?{dispStr:matStsValue.dispStr}:null}
                      onChange={(event, newValue) => {
                        setRows([]);

                        setMatStsValue(newValue ? newValue : null);


                        // console.log(newValue.keyStr);

                      }}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                        />
                      )} />
                  </Grid>
                  <Grid item xs={1} textAlign="end">Reservation</Grid>
                  <Grid item xs={3}>
                    <Autocomplete
                     noOptionsText="No items found"
                      options={reservations}
                      open={reservationOpen}
                      value={invtTypValue?{dispStr:invtTypValue.dispStr}:null}
                      onOpen={() => {
                        reservations.length < 1 ?
                          getValue(
                            { prsMd: "R" },
                            setReservations,
                            setReservationOpen
                          )
                          : setReservationOpen(true);


                      }}
                      onClose={() => {
                        setReservationOpen(false);
                      }}
                      onChange={(event, newValue) => {
                        setInvtTypValue(newValue ? newValue : null)
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.dispStr === value.dispStr
                      }
                      getOptionLabel={(option) => option.dispStr}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  <Grid item xs={1} textAlign="end">End-User</Grid>
                  <Grid item xs={3}>
                    <Autocomplete
                     noOptionsText="No items found"
                      open={openEndUser}
                      onOpen={() => {
                        getValue(
                          { prsMd: "E", fltrStr: millValue ? `${millValue.keyStr}` : "" },
                          setEndUserOption,
                          setOpenEndUser
                        );
                      }}
                      onClose={() => {
                        setOpenEndUser(false);
                      }}
                      value={endUserValue ? { dispStr: endUserValue.dispStr } : null}
                      options={endUserOption}
                      isOptionEqualToValue={(option, value) =>
                        option.dispStr === value.dispStr
                      }
                      getOptionLabel={(option) => option.dispStr}
                      onChange={(event, newValue) => {
                        setRows([]);
                        setEndUserValue(newValue ? newValue : null);

                        setPartNoValue(null)
                        setPartNoInputValue("")
                      }}
                      renderInput={(params) => <TextField onChange={(e) => SearchServiceCall(e.target.value, { prsMd: "E", fltrStr: millValue ? `${millValue.keyStr}` : "", srchStr: e.target.value }, setEndUserOption,
                        setOpenEndUser)}{...params} />}
                    />
                  </Grid>



                  <Grid item xs={1} textAlign="end">Part No</Grid>
                  <Grid item xs={3}>
                    <Autocomplete
                     noOptionsText="No items found"
                      freeSolo
                      forcePopupIcon
                      open={openPartNo}
                      value={partNoValue ? (typeof partNoValue === 'string' ? partNoValue : { dispStr: partNoValue.dispStr }) : null}
                      inputValue={partNoInputValue}
                      onInputChange={(event, newInputValue, reason) => {
                        setPartNoInputValue(newInputValue);
                        if (newInputValue && reason === 'input') {
                          setOpenPartNo(true);
                          SearchServiceCall(newInputValue, { prsMd: "P", fltrStr: `${millValue ? millValue.keyStr : ""}|${endUserValue ? endUserValue?.keyStr : ""}`, srchStr: newInputValue }, setPartNoOption,
                            () => setOpenPartNo(true));
                        } else if (!newInputValue) {
                          setOpenPartNo(false);
                        }
                      }}
                      onOpen={() => {
                        setOpenPartNo(true);
                        if (!partNoInputValue) {
                          getValue({ prsMd: "P", fltrStr: `${millValue ? millValue.keyStr : ""}|${endUserValue ? endUserValue?.keyStr : ""}` }, setPartNoOption, setOpenPartNo);
                        }
                      }}
                      onClose={(event, reason) => {
                        if (reason === 'selectOption' || reason === 'blur' || reason === 'escape') {
                          setOpenPartNo(false);
                        }
                      }}
                      options={partNoOption}
                      isOptionEqualToValue={(option, value) =>
                        typeof value === 'string' ? option.dispStr === value : option.dispStr === value.dispStr
                      }
                      getOptionLabel={(option) => typeof option === 'string' ? option : option.dispStr}
                      onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                          setPartNoValue({ keyStr: newValue, dispStr: newValue });
                          setPartNoInputValue(newValue);
                        } else {
                          setPartNoValue(newValue ? newValue : null);
                          setPartNoInputValue(newValue ? newValue.dispStr : "");
                        }
                        setRows([]);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>

                  <Grid item xs={1} textAlign="end">End-User PO</Grid>
                  <Grid item xs={3}>
                    <TextField

                       value={endUserPOValue||""}
                      onChange={(e) => {
                        setEndUserPOValue(e.target.value)
                        setRows([]);
                      }}
                    />
                  </Grid>
                  <Grid item xs={1} textAlign="end">Use Metric Units</Grid>

                  <Grid item xs={3}>

                    <SwitchPro
                      checked={checked}
                      onChange={(e) => {
                        toggleMetricUnits()
                        setRows([])
                      }}
                      inputProps={{ 'aria-label': 'controlled' }} />
                  </Grid>
                </Grid>

                <Stack spacing={"5px"} direction="row">
                  <Button
                    onClick={dimensionFilterToggler}
                    // sx={{ margin: "3px" }}
                    styletype="icon">
                    <SquareFootIcon />
                  </Button>
                 
                  <Button
                    // onClick={() => handleGo()}
                    type="submit"
                    styletype="icon" >
                    <PlayArrowIcon />
                  </Button>
                  <Button
                    onClick={clear}
                    // sx={{ margin: "3px" }}
                    >
                  clear
                  </Button>

        
                </Stack>
              </Stack>
              {dimensionFilterVisibility ? (
                <>
                  <div className="spacing" />
                  <Container
                    className="ixSeparatorLineForFilter"
                    sx={{ height: "1px" }}
                  />
                  <div className="spacing" />
                  <Grid container sx={{ width: "80%" }} spacing={2} direction="row">
                    <Grid item xs={1} textAlign="end">Width From</Grid>
                    <Grid item xs={3}>

                      <TextField
                        sx={{ width: "190px" }}
                        type="number"
                        value={widthFromValue || ""}
                        onChange={(e) => {
                          setWidthFromValue(e.target.value)
                          setRows([])
                        }}
                      />
                    </Grid>
                    <Grid item xs={1} textAlign="end">Length From</Grid>
                    <Grid item xs={3}>

                      <TextField
                        type="number"
                        value={lengthFromValue || ""}
                        sx={{ width: "190px" }}
                        onChange={(e) => {
                          setLengthFromValue(e.target.value)
                          setRows([])
                        }}
                      />
                    </Grid>
                    <Grid item xs={1} textAlign="end">Gauge From</Grid>
                    <Grid item xs={3}>

                      <TextField
                        type="number"
                        value={gaugeFromValue || ""}
                        sx={{ width: "190px" }}
                        onChange={(e) => {
                          setGaugeFromValue(e.target.value)
                          setRows([])
                        }}
                      />
                    </Grid>
                    <Grid item xs={1} textAlign="end">Width To</Grid>
                    <Grid item xs={3}>

                      <TextField
                        type="number"
                        value={widthToValue || ""}
                        sx={{ width: "190px" }}
                        onChange={(e) => {
                          setWidthToValue(e.target.value)
                          setRows([])
                        }}
                      />
                    </Grid>
                    <Grid item xs={1} textAlign="end">Length To</Grid>
                    <Grid item xs={3}>

                      <TextField
                        type="number"
                        value={lengthToValue || ""}
                        sx={{ width: "190px" }}
                        onChange={(e) => {
                          setLengthToValue(e.target.value)
                          setRows([])
                        }}
                      />
                    </Grid>
                    <Grid item xs={1} textAlign="end">Gauge To</Grid>
                    <Grid item xs={3}>

                      <TextField
                        type="number"
                        value={gaugeToValue || ""}
                        sx={{ width: "190px" }}
                        onChange={(e) => {
                          setGaugeToValue(e.target.value)
                          setRows([])
                        }}
                      />
                    </Grid>
                  </Grid>

                </>
              ) : null}
            </form>
          </Container>
        ) : (
          <Container className="ixFilterContainer" sx={{ height: "auto" }}>
            <Container
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={() => setFilterVisibility(true)}
                sx={{ margin: "3px" }}
                styletype="icon"
              >
                <ExpandMoreIcon />
              </Button>
            </Container>
          </Container>
        )}
        <div className="spacing"> </div>

        {/* Data Table */}
        <Container
          className="ixBrowseGridLayout"
          sx={{ display: "flex", flexDirection: "column" }}
        >

          {rows.length > 0 ? <Container className="ixBrowseGridActionBar" sx={{ height: "50px " }}>
            <Stack
              className="ixBrowseGridActionBarContents"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={0.5}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Button styletype="icon" onClick={handleMore}>
                  <MoreVertIcon />
                </Button>
              </Stack>
            </Stack>

            <Menu
              PaperProps={{
                className: "invPopupMenuVeryDark",
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
            >
              <MenuItem onClick={handlePrint} >

                Export to PDF</MenuItem>
              <MenuItem onClick={exportToXls} >

              Export to XLS
              </MenuItem>
              <MenuItem>Help</MenuItem>
            </Menu>
          </Container>
            : null}
          <Container className="ixBrowseGridContainer">
            <DataGridPro
              getRowClassName={(params) => params.row.isTot === 1 ? `bold` : ``}
              headerHeight={40}
              columnBuffer={10}
              hideFooter={true}
              apiRef={apiRef}
              columns={assetColumns}
              rowHeight={30}
              disableColumnMenu={true}
              getRowId={(row) => row.rowId}
              rows={rows}
              loading={!rows.length}
              onCellClick={handleCellClick}
            />
          </Container>
        </Container>
      </Container>
      {
        openPdf ?
          <Box style={{
            flex: 1,
            displayPrint: 'block',
          }}>
            <InventoryPdf ref={componentRef} data={openPdf} wgtUm={wgtUm}filter={pdfFilter} />
          </Box>
          : null
      }
    </>
  );
}
export default BrowseContainer;
